import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionFillGapsAnswerOptionsSchema = z.object({
  id: z.string(),
  content: z.string().min(1, 'Opis jest wymagany').max(512),
  correct: z.boolean(),
  explanation: z.string().optional(),
});

export const questionFillGapsAnswerSchema = z.object({
  id: z.string(),
  points: z
    .number({
      error: 'Podaj liczbę punktów',
    })
    .positive('Punkty muszą być liczbą dodatnią'),
  options: z.array(questionFillGapsAnswerOptionsSchema).min(2, 'Minimum 2 opcje').max(10, 'Maksimum 10 opcji'),
});

export const questionFillGapsSchema = questionBaseSchema
  .extend({
    type: z.literal(QuestionType.FILL),
    gapsContent: z.string().min(1, 'Treść luk jest wymagana').max(2048),
    gaps: z.array(questionFillGapsAnswerSchema).min(1, 'Minimum 1 luka').max(10, 'Maksimum 10 luk'),
  })
  .refine(
    (data) => {
      const gapMatches: RegExpExecArray[] = Array.from(data.gapsContent.matchAll(/\[([^\]]+)\]/g));
      const gapIdsInContent: (string | undefined)[] = gapMatches.map((m) => m[1]);
      const gapIdsDefined: string[] = data.gaps.map((g) => g.id);
      return gapIdsInContent.every((id: string | undefined) => id === undefined || gapIdsDefined.includes(id));
    },
    {
      message: 'Wszystkie luki w treści muszą odpowiadać zdefiniowanym lukom',
      path: ['gapsContent'],
    }
  )
  //gaps must be unique
  .refine(
    (data) => {
      const ids = data.gaps.map((g) => g.id);
      const uniqueIds = new Set(ids);
      return uniqueIds.size === ids.length;
    },
    {
      message: 'Identyfikatory luk muszą być unikalne',
      path: ['gaps'],
    }
  );

export type QuestionFillGapsAnswerOptionsSchema = Infer<typeof questionFillGapsAnswerOptionsSchema>;

export type QuestionFillGapsAnswerSchema = Infer<typeof questionFillGapsAnswerSchema>;

export type QuestionFillGapsSchema = Infer<typeof questionFillGapsSchema>;
